export default "__VITE_ASSET__CNVSiBN8__"